import { useQuery, useQueryClient, useMutation } from '@tanstack/vue-query';

import { getSkipPage } from '@/utils/getSkipPage';
import { driverService } from '@/api/transport/driver';
import getMessageError from '@/utils/getMessageError';
import { toast } from '@/utils/programaticToast';
import { getToastContentComponent } from '@/utils/getToastContentComponent';

export function useEditDriver() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ newDriver, id, isFormatedBody }) => driverService.edit(newDriver, id, isFormatedBody),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['drivers'] });
    },
    onError: (error) => {
      toast.open({
        variant: 'error',
        position: 'bottom',
        component: getToastContentComponent({ title: 'Ocorreu um erro', describe: getMessageError(error), typeIcon: 'error' }),
        closable: true,
        duration: 4000
      });
    }
  });
}

export function useCreateDriver() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (newDriver) => driverService.create(newDriver),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['drivers'] });
      toast.open({
        variant: 'success',
        position: 'bottom',
        component: getToastContentComponent({ title: 'Criado com sucesso', describe: 'Motorista foi criado com sucesso em nosso sistema', typeIcon: 'success' }),
        closable: true,
        duration: 4000
      });
    },
    onError: (error) => {
      toast.open({
        variant: 'error',
        position: 'bottom',
        component: getToastContentComponent({ title: 'Ocorreu um erro', describe: getMessageError(error), typeIcon: 'error' }),
        closable: true,
        duration: 4000
      });
    }
  });
}

export function useGetAll(queryParams) {
  return useQuery({
    queryKey: ['drivers', queryParams],
    queryFn: async({ signal }) => {
      try {
        const { currentPage, perPage, cpf, status, name } = queryParams.value;
        const skip = getSkipPage(currentPage);

        const params = {
          skip,
          take: perPage,
          active: status,
          document: cpf,
          name
        };

        const res = await driverService.getAll(params, signal);

        return res;
      } catch (error) {
        if (error.response && error.response.status === 400) {
          return [];
        }

        throw error;
      }
    }
  });
}

